import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      const roles = this.authService.getRoles();
      if (roles.includes('Admin')) {
        this.router.navigate(['/stolbovi']);
      } else {
        this.router.navigate(['/add']);
      }
      return false;
    }
    return true;
  }
}
